import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Отбор каталога живёт в адресе, а вкладка «Каталог» ведёт на голый
 * `/catalog` — после корзины фильтры пропадали. Здесь запоминается последний
 * адрес каталога, и вкладка возвращает на него, как раздел приложения
 * возвращает туда, где его оставили. Лежит и в sessionStorage: перезагрузка
 * страницы его не теряет.
 */
export const CATALOG_STORAGE_KEY = 'dorixona.catalog'

export const CATALOG_PATH = '/catalog'

let lastSearch = readStored()

function readStored(): string {
  try {
    return sessionStorage.getItem(CATALOG_STORAGE_KEY) ?? ''
  } catch {
    return ''
  }
}

function remember(search: string) {
  lastSearch = search
  try {
    sessionStorage.setItem(CATALOG_STORAGE_KEY, search)
  } catch {
    // Хранилище закрыто — отбор останется только до перезагрузки.
  }
}

/** Следит за адресом: пока открыт каталог, его отбор — последний. */
export function useCatalogMemory(): void {
  const { pathname, search } = useLocation()
  useEffect(() => {
    if (pathname === CATALOG_PATH) remember(search)
  }, [pathname, search])
}

/**
 * Куда ведёт вкладка «Каталог» — всегда на оставленный отбор, и повторное
 * касание в самом каталоге его не сбрасывает. В каталоге берём текущий адрес:
 * запомненный отстаёт на один показ, и касание вернуло бы прошлый отбор.
 */
export function catalogTabTarget({
  pathname,
  search,
}: {
  pathname: string
  search: string
}): string {
  return pathname === CATALOG_PATH ? `${CATALOG_PATH}${search}` : `${CATALOG_PATH}${lastSearch}`
}

/** Для тестов: забыть отбор. */
export function resetCatalogMemory(): void {
  lastSearch = ''
}
